import { atom } from 'jotai';
import { globalLoaderAtom } from './globalStateAtoms';
import { GetRequest } from '../api';
import { urls } from '../constants';

export const lrStatusAtom = atom([]);

export const fetchLrStatusAtom = atom(
  null,
  async (get, set, requestData) => {
    set(globalLoaderAtom, true);
    try {
      const res = await GetRequest(urls.cargoLrStatus, requestData);
      set(lrStatusAtom, res);
    } catch (err) {
      console.error('Error fetching LR status:', err);
    } finally {
      set(globalLoaderAtom, false);
    }
  }
);